import { BankType, BrandType, Country } from '../../generated/graphql';
import { getRepeatableSpaceBancoDeBogota } from '../entities/banco_de_bogota/getRepeatableSpaceBancoDeBogota';
import { GetRepeatableSpaceBase } from '../types/GetRepeatableSpaceBase';
import { getUndefinedRepeatableSpace } from '../utils/getUndefinedRepeatableSpace';

const { Tranquiapp } = BrandType;
const { BancoDeBogota } = BankType;

export const getRepeatableSpaceByEntity: GetRepeatableSpaceBase = (
  group,
  space,
  context,
) => {
  const { bank, brand, country } = context;

  // we don't have other countries at the moment
  if (country !== Country.Co) return getUndefinedRepeatableSpace(true);

  if (brand === Tranquiapp) {
    switch (bank) {
      case BancoDeBogota: return getRepeatableSpaceBancoDeBogota(group, space, context);
      default: return getUndefinedRepeatableSpace();
    }
  }

  return getUndefinedRepeatableSpace();
};
